import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { LinearProgress, Box, Typography, Button } from '@mui/material';
import { Icon } from '@iconify/react';
import cloudUploadOutline from '@iconify/icons-eva/cloud-upload-outline';
// contexts
import { useAuth } from '../../../contexts/Auth';
import { SettingsContext } from '../../../contexts/Settings';
// services
import { uploadFile } from '../../../services/Upload';
import { updateSettings } from '../../../services/Config';

UploadFile.propTypes = {
  settingsId: PropTypes.string.isRequired,
  fileUrl: PropTypes.string,
  fileField: PropTypes.string.isRequired,
  background: PropTypes.string
};

export default function UploadFile({ settingsId, fileUrl, fileField, background }) {
  const { authUser } = useAuth();
  const { authSettings } = useContext(SettingsContext);

  const [file, setFile] = useState({
    selected: undefined,
    current: undefined,
    progress: 0,
    hasError: false,
    url: fileUrl
  });

  const handleChooseFile = (e) => {
    setFile((currentFile) => ({
      ...currentFile,
      selected: e.target.files[0]
    }));
  };

  const handleUpload = async () => {
    const current = file.selected;

    setFile((currentFile) => ({
      ...currentFile,
      progress: 0,
      current,
      hasError: false
    }));

    try {
      const idToken = await authUser.getIdToken();
      const headers = {
        Authorization: `Bearer ${idToken}`,
        'Account-Key': authSettings.server.path
      };

      const payloadFile = {
        file: current,
        folder: `producer/${authUser.uid}`
      };

      // TODO: Melhorar progress.
      const file = await uploadFile({ payload: payloadFile, headers }, (e) => {
        setFile((currentFile) => ({
          ...currentFile,
          progress: Math.round((99 * e.loaded) / e.total)
        }));
      });

      const payloadSettings = {
        [fileField]: file.url
      };

      await updateSettings({ headers, payload: payloadSettings, id: settingsId });

      setFile((currentFile) => ({
        ...currentFile,
        url: file.url,
        progress: 100,
        current: undefined,
        selected: undefined
      }));

      window.location.reload();
    } catch (err) {
      console.error(err);

      setFile((currentFile) => ({
        ...currentFile,
        progress: 0,
        hasError: true
      }));
    }
  };

  const { selected, current, progress, url, hasError } = file;

  return (
    <Box>
      <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Button variant="outlined" component="label" size="large">
            Choose File
            <input hidden accept="image/*" type="file" onChange={handleChooseFile} />
          </Button>
          <Box sx={{ ml: 2 }}>{selected ? selected.name : null}</Box>
        </Box>
        <Box sx={{ ml: 'auto' }}>
          <Button
            className="btn-upload"
            color="primary"
            variant="contained"
            component="span"
            size="large"
            disabled={!selected}
            onClick={handleUpload}
            endIcon={<Icon icon={cloudUploadOutline} />}
          >
            Upload
          </Button>
        </Box>
      </Box>

      {current && (
        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
          <Box width="100%" mr={1}>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
          <Box minWidth={35}>
            <Typography variant="body2" color="textSecondary">{`${progress}%`}</Typography>
          </Box>
        </Box>
      )}

      {hasError && (
        <Typography variant="subtitle2" color="error">
          An error occurred! Please, try again.
        </Typography>
      )}

      {url && (
        <Box sx={{ mb: 5, p: background ? 2 : 0, background, textAlign: 'center' }}>
          <Box
            component="img"
            src={url}
            sx={{ display: 'inline-block', maxWidth: '200px', maxHeight: 'auto' }}
          />
        </Box>
      )}
    </Box>
  );
}
